<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useLocalization } from './composables/useLocalization'
import { useAuthStore } from './stores/auth'
import { useRoute } from 'vue-router'
import ONEToast from './components/primevuecomponents/messages/ONEToast/ONEToast.vue'
import ConfirmDialog from 'primevue/confirmdialog'

const { isRTL, initializeLanguage } = useLocalization()
const authStore = useAuthStore()
const route = useRoute()

// Initialize language and direction on component mount
onMounted(() => {
  initializeLanguage()
  authStore.restoreState()
})

// Watch for route changes and scroll to top
watch(
  () => route.fullPath,
  () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
)
</script>

<template>
  <div class="app-wrapper">
    <ONEToast />
    <!--
      One app-wide ConfirmDialog. 30 screens call useConfirm().require(), but the
      service only queues the request — something has to render it. No screen did,
      so every one of those confirmations (delete, approve, cancel…) was silently
      dropped and the action never ran.
    -->
    <ConfirmDialog />
    <main :dir="isRTL ? 'rtl' : 'ltr'">
      <router-view></router-view>
    </main>
  </div>
</template>

<script lang="ts">
export default {
  name: 'App'
}
</script>

<style>
/* The typeface is loaded once in index.html — do not @import it again here,
   a second fetch is render-blocking and downloads the same file twice. */

:root {
  --font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

body {
  font-family: var(--font-family);
  margin: 0;
  padding: 0;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
